/**
 * FIDDUX PDF Report - Chart.js renderer
 * Converte chart config do JSON em Chart.js (line, area, bar).
 */

import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

const FIDDUX_COLORS = {
  primary: '#353535',
  accent: '#2AF598',
  secondary: '#00BA2D',
  tertiary: '#009658',
  bull: '#00BA2D',
  bear: '#F52A44',
  base: '#3A87DE',
};

function buildLineChartConfig(chart) {
  const data = chart.data || [];
  const labels = data.map((d) => d.year || d.label || d.x);
  const values = data.map((d) => d.value || d.y);
  return {
    type: 'line',
    data: {
      labels,
      datasets: [
        {
          label: chart._title || chart.title || 'Value',
          data: values,
          borderColor: FIDDUX_COLORS.accent,
          backgroundColor: FIDDUX_COLORS.accent + '20',
          fill: true,
          tension: 0.3,
          borderWidth: 2,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: true, position: 'top' },
      },
      scales: {
        x: { grid: { display: false }, ticks: { maxRotation: 0 } },
        y: { beginAtZero: false, grid: { color: '#e2e8f0' } },
      },
    },
  };
}

function buildAreaChartConfig(chart) {
  const dataObj = chart.data || {};
  const base = dataObj.base || [];
  const bull = dataObj.bull || [];
  const bear = dataObj.bear || [];
  const labels = base.map((d) => d.year || d.label) || [];
  return {
    type: 'line',
    data: {
      labels,
      datasets: [
        {
          label: 'Base',
          data: base.map((d) => d.value),
          borderColor: FIDDUX_COLORS.base,
          backgroundColor: FIDDUX_COLORS.base + '30',
          fill: true,
          tension: 0.3,
          borderWidth: 2,
        },
        {
          label: 'Bull',
          data: bull.map((d) => d.value),
          borderColor: FIDDUX_COLORS.bull,
          backgroundColor: FIDDUX_COLORS.bull + '20',
          fill: true,
          tension: 0.3,
          borderWidth: 2,
        },
        {
          label: 'Bear',
          data: bear.map((d) => d.value),
          borderColor: FIDDUX_COLORS.bear,
          backgroundColor: FIDDUX_COLORS.bear + '20',
          fill: true,
          tension: 0.3,
          borderWidth: 2,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: true, position: 'top' },
      },
      scales: {
        x: { grid: { display: false }, ticks: { maxRotation: 0 } },
        y: { beginAtZero: false, grid: { color: '#e2e8f0' } },
      },
    },
  };
}

export function renderCharts(container) {
  if (!container) return [];
  const chartInstances = [];
  const chartContainers = container.querySelectorAll('[data-chart-config]');
  chartContainers.forEach((div) => {
    try {
      const configEnc = div.getAttribute('data-chart-config');
      const chartConfig = JSON.parse(decodeURIComponent(configEnc || '{}'));
      const canvas = div.querySelector('canvas');
      if (!canvas) return;
      let cfg;
      if (chartConfig.type === 'area_chart_with_scenarios') {
        cfg = buildAreaChartConfig(chartConfig);
      } else {
        cfg = buildLineChartConfig(chartConfig);
      }
      const instance = new Chart(canvas, cfg);
      chartInstances.push(instance);
    } catch (e) {
      console.warn('Chart render error:', e);
    }
  });
  return chartInstances;
}

export function destroyCharts(instances) {
  (instances || []).forEach((c) => c.destroy());
}
